/* Route ids are dotted strings used throughout the content ("gitar.egz.1", "araclar.akort").
   They map 1:1 to URL paths ("/gitar/egz/1"); "ana" is the home page "/". */
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';

export type RouteId = string;

export const toPath = (id: RouteId): string => (!id || id === 'ana' ? '/' : `/${id.split('.').join('/')}`);

export function fromPath(pathname: string): RouteId {
  const id = pathname
    .replace(/^\/+|\/+$/g, '')
    .split('/')
    .filter(Boolean)
    .join('.');
  return id || 'ana';
}

/** Navigate by route id. */
export function useGo(): (id: RouteId) => void {
  const navigate = useNavigate();
  return useCallback((id: RouteId) => navigate(toPath(id)), [navigate]);
}

/** Current route id, e.g. "akor.sarki.sahil-yolu". */
export function useRouteId(): RouteId {
  return fromPath(useLocation().pathname);
}

/** Old builds used hash routes (#gitar.egz.1); keep those links working. */
export function legacyHashPath(hash: string): string | null {
  const id = hash.replace(/^#/, '');
  return /^[a-z0-9.\-_~]+$/i.test(id) ? toPath(id) : null;
}
